import { render } from "./FilterPage.vue?vue&type=template&id=1f406a60"
import script from "./FilterPage.vue?vue&type=script&lang=js"
export * from "./FilterPage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__